import { createAction } from "@reduxjs/toolkit"

export const addPayment = createAction('payments/addPayment')
export const removePayment = createAction('payments/removePayment')
export const addAll = createAction('payments/addAll')
export const clearPayments = createAction('payments/clearPayments')